import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { recurseLangParam } from '@fcom/common/utils/route-utils';
import { SentryLogger, RootPaths } from '@fcom/core';
import { isCountryCode, isDestinationCode } from '@fcom/ond-marketing-landing-core/services/utils';

@Injectable()
export class OndMarketingLandingViewPageGuard implements CanActivate {
  constructor(
    private sentryLogger: SentryLogger,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const lang = recurseLangParam(route);
    const originLocationCode = route.params['originLocationCode'] || '';
    const destinationLocationCode = route.params['destinationLocationCode'] || '';

    if (this.isInvalidRoute([originLocationCode, destinationLocationCode])) {
      return this.deny(lang);
    }

    return true;
  }

  // @TODO: check that page for origin and destination is actually valid when data is available
  private isValidCode(code: string): boolean {
    return isCountryCode(code) || isDestinationCode(code);
  }

  private isInvalidRoute(codes: string[]): boolean {
    const hasNoValidRoutes = codes.filter((code) => this.isValidCode(code)).length === 0;
    const hasInvalidRoute = codes.some((code) => code && !this.isValidCode(code));

    return hasNoValidRoutes || hasInvalidRoute;
  }

  private deny(lang: string): false {
    this.sentryLogger.warn('Someone tried to access OnD marketing landing page without valid flight pair parameters');
    this.router.navigateByUrl(`/${lang}/${RootPaths.OND_MARKETING_LANDING_ROOT}`, { replaceUrl: true });
    return false;
  }
}
